import _, { isEmpty } from "lodash";
import React from "react";
import styled, { css } from "styled-components";
import { DesktopMenuContext } from "../../contexts/VerticalDesktopMenu";
import { useDebug } from "../../hooks";
import { Types } from "../../types";
import { Helpers } from "../../utils";
import { ReactSVG } from 'react-svg';
import Icon from "../Icon";

interface INavigation {
	items: any,
	config: any,
	theme: any
}

const Navigation = () => {
	useDebug('Components/Navigation')

	const { items, config, theme, handleReset, navRef } = React.useContext(DesktopMenuContext);

	return (
		<StyledNavigation {...{ config, theme }} ref={navRef}>
			<StyledMenuItems {...{ config, theme }}>
				{items.filter((item: any) => item?.alignment !== 'right').map((menuItem: Types.MenuItem) => <MenuItem key={menuItem.id} {...menuItem} />)}
			</StyledMenuItems>
			<StyledMenuItems {...{ config, theme }}>
				{items.filter((item: any) => item?.alignment === 'right').map((menuItem: Types.MenuItem) => <MenuItem key={menuItem.id} {...menuItem} />)}
			</StyledMenuItems>
		</StyledNavigation>
	)
}


interface IMenuItem extends Types.MenuItem {
	onSelect: Function,
	theme: any
}

const MenuItem = ({ isCategoryMenu, openByDefault, alignment, ...item }: Types.MenuItem) => {

	const { config, theme, handleSelect, active } = React.useContext(DesktopMenuContext);

	return (
		<StyledMenuItem className={active === item.id ? 'active' : ''} {...{ config, theme, isCategoryMenu, alignment }} onMouseEnter={() => handleSelect(item.id)}>
			<StyledMenuItemLink href={item.permalink} {...{ config, theme }} >
				{(!_.isUndefined(item?.icon) && item.icon) && 
					<ReactSVG
						css={{ color: "currentColor" }}
						className="item-icon"
						src={item.icon}
					/>
				}
				<span>{item.label}</span>
			</StyledMenuItemLink>
			{!_.isEmpty(item?.items) && <Icon id={'angleDown'} type="outlined" size={0.75} {...{ config }} />}
		</StyledMenuItem>
	)
}

export default Navigation

const StyledNavigation = styled.nav<any>(({ config, theme }) => css`
	display: flex;
	justify-content: space-between;
	gap: 1em;
	width: 100%;
	overflow: hidden;
	height: 3em; // navigationBar.height
	color: var(--secondary); // navigationBar.textColor
	font-weight: 600; // navigationBar.textWeight
`)

const StyledMenuItems = styled.ul<any>(({ config, theme }) => css`
	display: flex;
	height: 100%;
	${Helpers.clamp('column-gap', (2), (1), 5)};
	list-style: none;
	padding: 0;
	margin: 0;
`);

const StyledMenuItemLink = styled.a<any>(({ config, theme }) => css`
display: flex;
text-decoration: none;
	align-items: center;
	${Helpers.clamp('font-size', 0.9, 1, 1)}
	font-weight: 500;
	
	//line-height: 0.85; // Rubik - compensate additional height

	& ~ svg {
		margin-left: 0.75em;
	}
	
	&::before {
		content: '';
    position: absolute;
    top: 100%;
    left: 0;
    width: 0;
    height: 0.125em;
		color: currentColor;
    border-radius: var(--radius-m);
    transition: width 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.15);
    background-color: var(--primary);
	}

	&,&:hover {
		text-decoration: none;
		color: currentColor;
	}
`)

const StyledMenuItem = styled.li<any>(({ isCategoryMenu, config, theme, alignment }) => css`
	display: flex !important;
	position: relative;
	cursor: pointer;
	transition: all 250ms ease-in-out;
	.item-icon {
		width: 1.5em;
		height: 1.5em;
		margin-right: 0.5em;
		color: currentColor;
		svg {
			width: 100%;
			height: 100%;
		}
	}
	&:hover,
	&.active {
		color: var(--primary);
	}
	height: 100%;
	align-items: center;
	position: relative;
`)